import createReducer from '../../../data/shared/createReducer';
import { UPDATE_INVOICES_FILTERS, REQUEST_INVOICES, RECEIVE_INVOICES, FAILURE_INVOICES, UNLOAD_INVOICE } from '../constants/action_types';
import { isEmpty } from "lodash";
let today = new Date();

const initialState = {
    isFetching: false,
    entities: {
        invoices: null
    },
    filters : {
        year: today.getFullYear(),
        month: null,
        query: null,
    },
    nextPage: 0,
    reachedEnd: false,
};

const requestInvoices = (state, action) => {
    return {
        ...state,
        isFetching: true,
        nextPage: action.reset ? 0 : state.nextPage
    }
}

const failureInvoices = (state, action) => ({
    ...state,
    isFetching: false,
    entities: {
        invoices: {
            error: "error"
        }
    }
})

const receiveInvoices = (state, action) => {
    let entities = {};

    if (state.nextPage == 0) {
        entities = action.data;
    } else {
        entities = state.entities.invoices.concat(action.data)
    }

    return {
        ...state,
        isFetching: false,
        nextPage: state.nextPage + 1,
        reachedEnd: isEmpty(action.data),
        entities: {
            invoices: entities
        }
    }
}

const updateFilters = (state, action) => ({
    ...state,
    filters: {
        ...state.filters,
        ...action.filters
    },
    nextPage: 0,
    reachedEnd: false
})

const unloadInvoice = () => ({
    ...initialState
})

const invoices = createReducer(initialState, {
    [REQUEST_INVOICES]: requestInvoices,
    [RECEIVE_INVOICES]: receiveInvoices,
    [FAILURE_INVOICES]: failureInvoices,
    [UPDATE_INVOICES_FILTERS]: updateFilters,
    [UNLOAD_INVOICE]: unloadInvoice,
});

export default invoices;